import React from 'react';

import { Body, Modal, Title } from '@icarros/ids-react';

import { ReactComponent as ExcludeAdIllustration } from '../../../../../../assets/rebranding/feedback/alerts/excluir-anuncio.svg';
import { Loading } from '../../../../../components/Loading';
import { pushSellerPFDashboardEvent } from '../../../../../../utils/pushToDataLayer';

import { ModalBody } from '../style';
import { getCurrentContent } from './utils/get-current-content';
import { ConfirmationStepProps } from './types/modal-deactivate';

export function ConfirmationStep({
  isDelete,
  handleDelete,
  loading,
  modalOpen,
  setCurrentModalView,
  setModalOpen,
  isDeleteLoading
}: ConfirmationStepProps): JSX.Element {
  const { bodyText, dataLayerSection, text, title } = getCurrentContent(isDelete);

  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          pushSellerPFDashboardEvent('voltar', dataLayerSection);
          setModalOpen(false);
        }
      ]}
      body={
        <ModalBody>
          {loading && <Loading isInner />}
          <ExcludeAdIllustration />
          <Title variant="default" size="base">
            tem certeza que deseja {text} o seu anúncio?
          </Title>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            {bodyText}
          </Body>
        </ModalBody>
      }
      title={title}
      mainButtonLoading={isDeleteLoading}
      secondaryButtonLoading={isDeleteLoading}
      mainButtonText={title}
      mainButtonMethod={() => {
        pushSellerPFDashboardEvent(title, dataLayerSection);
        if (isDelete) {
          handleDelete();
        } else {
          setCurrentModalView('reason');
        }
      }}
      secondaryButtonText="manter anúncio"
      secondaryButtonMethod={() => {
        pushSellerPFDashboardEvent('manter anúncio', dataLayerSection);
        setModalOpen(false);
      }}
    />
  );
}
